'use strict';exports.__esModule = true;var getFullName = function getFullName() {var firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var trimmedFirstName = firstName.trim();
  var trimmedLastName = lastName ? lastName.trim() : '';

  return trimmedLastName ? trimmedFirstName + ' ' + trimmedLastName : trimmedFirstName;
};exports.default =

getFullName;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/getFullName.js
// module id = 1268
// module chunks = 0